import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText } from "mdbreact";
import picc1 from "../../assets/calendar/calendarkru1.png";
import picc2 from "../../assets/calendar/calendarkru2.png";
import picc3 from "../../assets/calendar/calendarkru3.png";
import picc4 from "../../assets/calendar/calendarkru4.png";
import MetaTags from "react-meta-tags";

export default class Page5 extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (<>
            <MetaTags>
                <title>ปฏิทินการรับสมัคร ระดับประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
                <meta name="description" content="ปฏิทินการรับสมัคร ระดับประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู มหาวิทยาลัยราชภัฏกำแพงเพชร Calendar's Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="ปฏิทินการรับสมัคร ระดับประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู มหาวิทยาลัยราชภัฏกำแพงเพชร" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid >
                <MDBRow>
                    <MDBCol lg="1" md="1" sm="1"></MDBCol>
                    <MDBCol lg="10" md="10" sm="10">
                        <MDBCard>
                            <MDBCardBody>
                                <MDBCardTitle>
                                    ปฏิทินการรับสมัคร ระดับประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
                                </MDBCardTitle>
                                <MDBCardText>
                                    <img src={picc1} width="100%" />
                                    <img src={picc2} width="100%" />
                                    <img src={picc3} width="100%" />
                                    <img src={picc4} width="100%" />
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="1" md="1" sm="1"></MDBCol>
                </MDBRow>
            </MDBContainer>
        </>)
    }
}